export enum OrderDeliveryType {
    TAKEAWAY = 'TAKEAWAY',
    ON_SITE = 'ON_SITE',
    DELIVERY = 'DELIVERY',
}



// WEBPACK FOOTER //
// ./src/model/lib/enums/OrderDeliveryType.ts